import styled from '@emotion/styled';

import CardItems from '../../../components/Card/CardItems';
import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';
import { SimplifiedLogisticData } from './SimplifiedLogisticData';
import ComponentHeader from '../../../components/ComponentHeader/ComponentHeader';

const OurTrustedServices = () => {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 0.02,
  });

  return (
    <Container className='intersection-animate'>
      <HeaderSection>
        <ComponentHeader text="Why CML?" />
      </HeaderSection>
      {SimplifiedLogisticData.map((data, index) => (
        <CardItems
          key={index}
          header={data.header}
          description={data.description}
          src={data.src}
        />
      ))}
    </Container>
  );
};

export default OurTrustedServices;

const Container = styled.div`
  display: flex;
  gap: 60px;
  padding-bottom: 100px;
  flex-direction: column;
  width: 100%;
  overflow: hidden;

  &.animate {
    --ydist: 100%;

    & > *:nth-of-type(1) {
      animation-name: move, show;
      animation-delay: 0.2s;
      animation-duration: 0.5s;
      animation-fill-mode: backwards;
    }

    @keyframes move {
      from {
        transform: translateY(var(--ydist));
      }
      to {
        transform: 0;
      }
    }

    @keyframes show {
      from {
        opacity: 0;
      }
      50% {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }

    @media (max-width: 884px) {
    padding-bottom: 55px;
    gap: 24px;
  }
`;


const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

